import React, { useEffect, useState } from 'react';
import { Play, Pause, XCircle, RefreshCw, Clock, X } from 'lucide-react';
import { Card, Button, ProgressBar, StatusPill } from '../components/ui/Primitives';
export function RefreshJobs() {
  const [activeTab, setActiveTab] = useState('Running (3)');
  const [showNewJobModal, setShowNewJobModal] = useState(false);
  const [runningJobs, setRunningJobs] = useState([{
    id: 1,
    name: 'Nightly DNC refresh — Bonzo',
    type: 'System',
    progress: 68,
    records: '8,192 / 12,000',
    rate: '45/sec',
    eta: '1m 24s',
    paused: false
  }, {
    id: 2,
    name: 'GHL contact backfill',
    type: 'Manual',
    progress: 32,
    records: '1,500 / 4,680',
    rate: '12/sec',
    eta: '4m 10s',
    paused: false
  }, {
    id: 3,
    name: 'Five9 list reconciliation',
    type: 'System',
    progress: 89,
    records: '44,500 / 50,000',
    rate: '120/sec',
    eta: '45s',
    paused: false
  }]);
  useEffect(() => {
    const interval = setInterval(() => {
      setRunningJobs(prev => prev.map(job => {
        if (job.paused || job.progress >= 100) return job;
        return {
          ...job,
          progress: Math.min(100, job.progress + 1)
        };
      }));
    }, 2000);
    return () => clearInterval(interval);
  }, []);
  const handlePause = (id: number) => {
    setRunningJobs(prev => prev.map(j => j.id === id ? {
      ...j,
      paused: !j.paused
    } : j));
  };
  const handleCancel = (id: number) => {
    setRunningJobs(prev => prev.filter(j => j.id !== id));
  };
  return <div className="space-y-6 max-w-6xl mx-auto relative" data-id="element-803">
      {showNewJobModal && <div className="absolute inset-0 z-50 flex items-center justify-center" data-id="element-804">
          <div className="absolute inset-0 bg-slate-900/20 backdrop-blur-sm" onClick={() => setShowNewJobModal(false)} data-id="element-805" />
          <Card className="w-[400px] p-6 relative z-10 shadow-2xl animate-in zoom-in-95" data-id="element-806">
            <div className="flex justify-between items-center mb-4" data-id="element-807">
              <h3 className="text-lg font-semibold text-slate-900" data-id="element-808">
                Configure Refresh Job
              </h3>
              <button onClick={() => setShowNewJobModal(false)} className="text-slate-400 hover:text-slate-600" data-id="element-809">
                <X className="w-4 h-4" data-id="element-810" />
              </button>
            </div>
            <div className="space-y-4 mb-6" data-id="element-811">
              <div data-id="element-812">
                <label className="text-xs font-medium text-slate-700 mb-1.5 block" data-id="element-813">
                  Target Platform
                </label>
                <select className="w-full h-9 rounded-md border border-slate-300 bg-white px-3 text-sm focus:ring-2 focus:ring-electric-500" data-id="element-814">
                  <option data-id="element-815">Bonzo</option>
                  <option data-id="element-816">GoHighLevel</option>
                  <option data-id="element-817">Five9</option>
                </select>
              </div>
              <div data-id="element-818">
                <label className="text-xs font-medium text-slate-700 mb-1.5 block" data-id="element-819">
                  Sync Direction
                </label>
                <select className="w-full h-9 rounded-md border border-slate-300 bg-white px-3 text-sm focus:ring-2 focus:ring-electric-500" data-id="element-820">
                  <option data-id="element-821">Pull from Platform</option>
                  <option data-id="element-822">Push to Platform</option>
                </select>
              </div>
            </div>
            <div className="flex justify-end gap-3" data-id="element-823">
              <Button variant="outline" onClick={() => setShowNewJobModal(false)} data-id="element-824">
                Cancel
              </Button>
              <Button variant="primary" onClick={() => setShowNewJobModal(false)} data-id="element-825">
                Start Job
              </Button>
            </div>
          </Card>
        </div>}

      <div className="flex items-center justify-between" data-id="element-826">
        <div data-id="element-827">
          <h1 className="text-xl font-semibold text-slate-900" data-id="element-828">Refresh Jobs</h1>
          <p className="text-sm text-slate-500" data-id="element-829">
            Monitor and manage async background operations.
          </p>
        </div>
        <Button variant="primary" onClick={() => setShowNewJobModal(true)} data-id="element-830">
          <Play className="w-4 h-4 mr-2" data-id="element-831" /> New Job
        </Button>
      </div>

      <div className="grid grid-cols-4 gap-4" data-id="element-832">
        <StatTile label="Running" value={runningJobs.length.toString()} color="electric" data-id="element-833" />
        <StatTile label="Queued" value="12" color="slate" data-id="element-834" />
        <StatTile label="Completed Today" value="47" color="emerald" data-id="element-835" />
        <StatTile label="Failed Today" value="2" color="red" data-id="element-836" />
      </div>

      <Card className="overflow-hidden" data-id="element-837">
        <div className="flex border-b border-slate-200 px-2 bg-slate-50" data-id="element-838">
          {['Running (3)', 'Queued (12)', 'Completed', 'Failed'].map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className={`px-4 py-3 text-sm font-medium border-b-2 transition-colors ${tab === activeTab ? 'border-electric-500 text-electric-600' : 'border-transparent text-slate-500 hover:text-slate-700'}`} data-id="element-839">
              {tab}
            </button>)}
        </div>

        <div className="p-0" data-id="element-840">
          <table className="w-full text-left border-collapse" data-id="element-841">
            <thead className="bg-white border-b border-slate-200" data-id="element-842">
              <tr data-id="element-843">
                <th className="px-6 py-3 text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-844">
                  Job Name
                </th>
                <th className="px-6 py-3 text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-845">
                  Status / Progress
                </th>
                <th className="px-6 py-3 text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-846">
                  Records
                </th>
                <th className="px-6 py-3 text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-847">
                  Rate
                </th>
                <th className="px-6 py-3 text-xs font-medium text-slate-500 uppercase tracking-wider text-right" data-id="element-848">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-849">
              {activeTab === 'Running (3)' && runningJobs.map(job => <JobRow key={job.id} name={job.name} type={job.type} progress={job.progress} records={job.records} rate={job.rate} eta={job.eta} paused={job.paused} onPause={() => handlePause(job.id)} onCancel={() => handleCancel(job.id)} data-id="element-850" />)}
              {activeTab === 'Queued (12)' && [1, 2, 3, 4, 5].map(i => <tr key={i} className="hover:bg-slate-50 transition-colors" data-id="element-851">
                    <td className="px-6 py-4" data-id="element-852">
                      <div className="text-sm font-medium text-slate-900" data-id="element-853">
                        Pending Sync Job #{i}
                      </div>
                      <div className="flex items-center gap-2 mt-1" data-id="element-854">
                        <span className="text-[10px] px-1.5 py-0.5 bg-slate-100 text-slate-600 rounded uppercase tracking-wider" data-id="element-855">
                          System
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-4 w-64" data-id="element-856">
                      <StatusPill status="info" data-id="element-857" />
                    </td>
                    <td className="px-6 py-4 text-sm font-mono text-slate-600" data-id="element-858">
                      --
                    </td>
                    <td className="px-6 py-4 text-sm font-mono text-slate-600" data-id="element-859">
                      --
                    </td>
                    <td className="px-6 py-4 text-right" data-id="element-860">
                      <Button variant="outline" size="sm" className="text-red-600" data-id="element-861">
                        Cancel
                      </Button>
                    </td>
                  </tr>)}
              {activeTab === 'Completed' && [1, 2, 3, 4, 5, 6].map(i => <tr key={i} className="hover:bg-slate-50 transition-colors" data-id="element-862">
                    <td className="px-6 py-4" data-id="element-863">
                      <div className="text-sm font-medium text-slate-900" data-id="element-864">
                        Completed Sync Job #{i}
                      </div>
                    </td>
                    <td className="px-6 py-4 w-64" data-id="element-865">
                      <StatusPill status="success" data-id="element-866" />
                    </td>
                    <td className="px-6 py-4 text-sm font-mono text-slate-600" data-id="element-867">
                      12,000 / 12,000
                    </td>
                    <td className="px-6 py-4 text-sm font-mono text-slate-600" data-id="element-868">
                      --
                    </td>
                    <td className="px-6 py-4 text-right text-xs text-slate-500" data-id="element-869">
                      Completed 2h ago
                    </td>
                  </tr>)}
              {activeTab === 'Failed' && [1, 2].map(i => <tr key={i} className="hover:bg-slate-50 transition-colors" data-id="element-870">
                    <td className="px-6 py-4" data-id="element-871">
                      <div className="text-sm font-medium text-slate-900" data-id="element-872">
                        Failed Sync Job #{i}
                      </div>
                    </td>
                    <td className="px-6 py-4 w-64" data-id="element-873">
                      <StatusPill status="error" data-id="element-874" />
                    </td>
                    <td className="px-6 py-4 text-sm font-mono text-slate-600" data-id="element-875">
                      4,500 / 12,000
                    </td>
                    <td className="px-6 py-4 text-sm font-mono text-slate-600" data-id="element-876">
                      --
                    </td>
                    <td className="px-6 py-4 text-right" data-id="element-877">
                      <Button variant="outline" size="sm" data-id="element-878">
                        Retry Failed
                      </Button>
                    </td>
                  </tr>)}
            </tbody>
          </table>
        </div>
      </Card>
    </div>;
}
function StatTile({
  label,
  value,
  color
}: {
  label: string;
  value: string;
  color: string;
}) {
  const colors = {
    electric: 'text-electric-600 bg-electric-50 border-electric-100',
    slate: 'text-slate-700 bg-slate-50 border-slate-200',
    emerald: 'text-emerald-600 bg-emerald-50 border-emerald-100',
    red: 'text-red-600 bg-red-50 border-red-100'
  };
  return <Card className={`p-4 border ${colors[color as keyof typeof colors]}`} data-id="element-879">
      <div className="text-xs font-medium uppercase tracking-wider opacity-80 mb-1" data-id="element-880">
        {label}
      </div>
      <div className="text-2xl font-bold font-mono" data-id="element-881">{value}</div>
    </Card>;
}
function JobRow({
  name,
  type,
  progress,
  records,
  rate,
  eta,
  paused,
  onPause,
  onCancel
}: any) {
  return <tr className="hover:bg-slate-50 transition-colors" data-id="element-882">
      <td className="px-6 py-4" data-id="element-883">
        <div className="text-sm font-medium text-slate-900" data-id="element-884">{name}</div>
        <div className="flex items-center gap-2 mt-1" data-id="element-885">
          <span className="text-[10px] px-1.5 py-0.5 bg-slate-100 text-slate-600 rounded uppercase tracking-wider" data-id="element-886">
            {type}
          </span>
          <span className="text-xs text-slate-500 flex items-center" data-id="element-887">
            <Clock className="w-3 h-3 mr-1" data-id="element-888" /> Started 4m ago
          </span>
        </div>
      </td>
      <td className="px-6 py-4 w-64" data-id="element-889">
        <ProgressBar progress={progress} active={!paused && progress < 100} label={`${progress}%${paused ? ' (Paused)' : ''}`} eta={eta} data-id="element-890" />
      </td>
      <td className="px-6 py-4 text-sm font-mono text-slate-600" data-id="element-891">{records}</td>
      <td className="px-6 py-4" data-id="element-892">
        <div className="text-sm font-mono text-slate-700" data-id="element-893">{rate}</div>
        <div className="text-[10px] text-slate-400 mt-1" data-id="element-894">Limit: 100/sec</div>
      </td>
      <td className="px-6 py-4 text-right" data-id="element-895">
        <div className="flex justify-end gap-2" data-id="element-896">
          <Button variant="outline" size="sm" className="h-8 w-8 p-0" onClick={onPause} data-id="element-897">
            {paused ? <Play className="w-4 h-4" data-id="element-898" /> : <Pause className="w-4 h-4" data-id="element-899" />}
          </Button>
          <Button variant="outline" size="sm" className="h-8 w-8 p-0 text-red-600 hover:bg-red-50 hover:text-red-700" onClick={onCancel} data-id="element-900">
            <XCircle className="w-4 h-4" data-id="element-901" />
          </Button>
        </div>
      </td>
    </tr>;
}